<template>
  <main class="homepage">
    <HeroSection />
    <CardsSection />
    <VideoSection />
    <FaqSection />
    <BenefitsSection />
    <LogoSection :logos="logos" />
    <DeveloperTypeSection />
    <OurReachSection />
    <NewsSection
      v-if="articles"
      :articles="articles"
      section-title="What's new at<br /> Proxify?"
    />
  </main>
</template>

<script>
import HeroSection from './HeroSection/HeroSection.vue';
import CardsSection from '~/components/Common/BenefitsSection/BenefitsSection.vue';
import FaqSection from '~/components/Common/FaqSectionNew/FaqSection.vue';
import VideoSection from './VideoSection/VideoSection.vue';
import BenefitsSection from './BenefitsSection/BenefitsSection.vue';
import LogoSection from './LogoSection/LogoSection.vue';
import DeveloperTypeSection from './DeveloperTypeSection/DeveloperTypeSection.vue';
import OurReachSection from '~/components/Common/OurReachSection/OurReachSection.vue';
import NewsSection from '~/components/Common/NewsSection/NewsSection.vue';

export default {
  components: {
    HeroSection,
    CardsSection,
    FaqSection,
    BenefitsSection,
    LogoSection,
    DeveloperTypeSection,
    NewsSection,
    OurReachSection,
    VideoSection,
  },
  props: {
    articles: {
      type: Array,
      required: true,
    },
    logos: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import './HomePage.scss';
</style>
